import React, { useEffect, useRef } from 'react';
import Container from './Container';
import '../styles/AboutUs.css';
import { Helmet ,HelmetProvider} from "react-helmet-async";

const AboutUsSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('fade-in');
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
    <HelmetProvider>
      <Helmet>
  <meta
    name="description"
    content="Learn about INBI NextGen Innovations – Years of experience in building custom software, IoT, and ERP solutions. Founded by industry veterans, focused on innovation and user-friendly technology."
  />
  <meta name="keywords" content="about INBI NextGen Innovations, software company India, IoT experts, ERP providers, IT solutions" />

  {/* Open Graph */}
  <meta property="og:title" content=" INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta property="og:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today. "/>
  <meta property="og:image" content="/assets/Logoblue.jpg" />
  <meta property="og:url" content="https://inbinextgen.com/#about" />
  <meta property="og:type" content="website" />

  {/* Twitter */}
  
  <meta name="twitter:title" content=" INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta name="twitter:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today."/>
  <meta name="twitter:image" content="/assets/Logoblue.jpg" />
</Helmet>
    </HelmetProvider>
    

    <section id="about" className="about-us-section" ref={sectionRef}>
    <Container className="about-container">
      <div className="about-text">
    <h2>About INBI NextGen Innovations</h2>
    <p>
        At <b>INBI NextGen Innovations</b>, we are more than just software developers — we are visionaries with over <b>27 years of experience</b> in building 
    technology solutions that truly make a difference. 
    </p>
    <p>
      Founded by an industry veteran and successful entrepreneur, we combine <b>technical expertise, creative thinking,</b> and a <b>problem-solving 
  mindset</b> to deliver solutions that are <b>innovative, user-friendly, and scalable.</b> 
    </p>
    <div className="key-focus-areas">
      <div id='Key-area'><h4>Key Focus Areas: </h4></div>
    <ul>
      <li>Custom Software Development</li>
      <li>IoT Solutions</li>
      <li>ERP Systems </li>
      <li>RFID & Biometric Integration</li>
      <li>Industry-Specific Applications</li>
    </ul>
    </div>
    
    </div>
    <div className="about-image">
    <img 
      src="/assets/about.svg" 
      alt="About INBI NextGen Innovations" 
     
    />
    </div>
    
    </Container>
    </section>
    </>
  );
};export default AboutUsSection;

